module.exports = __webpack_public_path__ + "img/login-bg.76c526ad.svg";